<template>
    <b-card
        no-body
    >
        <b-card-header>
            <b-card-title class="d-flex justify-content-start">
                <div class="mr-1 line-height-1">
                    <feather-icon class="text-warning" size="17" icon="StarIcon" />
                </div>
                {{ $t('org.common.Notice Info') }}
            </b-card-title>
        </b-card-header>
        <b-card-body>
            <div v-if="stateFlag">
                <template v-if="boardDocuments.length > 0">
                    <div v-for="(item, index) in boardDocuments" :key="index" class="d-flex justify-content-between">
                        <b-card-text style="cursor:pointer" @click="fetchBoardDocument(item)">{{ item.subject }}</b-card-text>
                        <b-card-text>{{ new Date(item.timestamp*1).toLocaleDateString()}}</b-card-text>
                    </div>
                </template>
                <div v-else style="display:flex;justify-content:center">
                    <b-card-text v-if="Object.keys(authUserResource).length > 0">{{ $t('org.message.There is no notice')}}</b-card-text>
                    <b-card-text v-else>{{ $t('org.message.Prerequisites are required')}}</b-card-text>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center">
                <b-spinner label="Loading..." />
            </div>
        </b-card-body>
        <b-modal
            ref="notice_modal"
            content-class="shadow"
            :title="document.subject"
            centered
            ok-only
            ok-title="닫기"
        >
            <div class="d-flex justify-content-end">
                <b-card-text>{{new Date(parseInt(document.timestamp, 10)).toLocaleString()}}</b-card-text>
            </div>
            <template v-for="(item, itemIdx) in document.paragraphs">
                <div v-if="item.type=='p'" :key="itemIdx">
                    <b-card-text v-html="item.content"></b-card-text>
                </div>
                <div v-if="item.type=='img' && item.src!=''" :key="itemIdx">
                    <b-card-img :src="item.src" :style="{'width': item.width + 'px'}" />
                </div>
            </template>
        </b-modal>
    </b-card>
</template>

<script>
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
export default {
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        /* data */
        const document = ref({})
        const stateFlag = ref(true)

        /* computed */
        const userInfo = computed(() => store.getters.userInfo)
        const authUserResource = computed(() => store.getters.authUserResource)
        const boardDocuments = computed(() => store.getters.boardDocuments)
        const boardDocument = computed(() => store.getters.boardDocument)

        /* methods */
        const fetchBoardDocument = (item) => {
            store.dispatch('getBoardDocument', ({ timestamp: item.timestamp, service: item.service })).then((response) => {
                if (response.status === 200) {
                    document.value = response.data.document
                    vm.$refs.notice_modal.show()
                }
            })
        }

        /* init */
        if (userInfo.value.singedTcDt !== null) {
            stateFlag.value = false
            store.dispatch('getBoardDocuments').then((response) => {
                stateFlag.value = true
            })
        }
        return {
            document,
            stateFlag,
            authUserResource,
            boardDocuments,
            boardDocument,
            userInfo,
            fetchBoardDocument
        }
    }
}
</script>

<style>

</style>
